export const CUSTOMER_TYPE_PERSONAL = 1;
export const CUSTOMER_TYPE_BUSINESS = 2;
export const CUSTOMER_TYPE_BUSINESS_NO_VAT = 3;
export const CUSTOMER_TYPE_OUTSIDE_OF_EU = 4;